import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom"
import { Toaster } from "react-hot-toast";
import { Analytics } from "@vercel/analytics/react";

import { AppProvider } from "./context/AppContext";

//ReactDOM.render(
//  <AppProvider>
//    <App />
//  </AppProvider>,
//  document.getElementById('root')
//);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
     <AppProvider>
       <App />
     </AppProvider>,
      <Toaster />
      <Analytics/>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
